module.exports = __webpack_public_path__ + "img/Damp1_717x350.jpg";